import React from "react";
import { auth } from "../../backend/firebase";
import { useNavigate } from "react-router-dom";
import Signup from "./Signup";
import logo from "../assets/logo.svg";
import { GoogleAuthProvider } from "firebase/auth";
import ProfilePic from "./ProfilePic";
import "./Navbar.css";


export default function Navbar({ user }) {
  const navigate = useNavigate();

  const goInvest = () => {
    navigate("/invest");
  };
  const goEducation = () => {
    navigate("/homeeducation");
  };

  const goHome = () => {
    navigate("/");
  };

  const goTest = () => {
    navigate("/profile");
  };
  const goLogin = () => {
    navigate("/login");
    console.log('bruh')
};
  const username = user?.displayName ?? "";

  return (
    <nav class="flex items-center justify-between flex-wrap p-6">
      <div class="flex items-center justify-center flex-shrink-0 text-[#73C4FC] mr-6">
        <div class="flex font-bold text-3xl tracking-tight">
          <button
            class="block mt-4 lg:inline-block lg:mt-0 text-[#73C4FC] text-2xl"
            onClick={goHome}
          >
            <img
              src={logo}
              alt="..."
              class="lg:inline-block object-scale-down h-16 w-16 mt-4"
            />
          </button>
          <div className=" text-3xl mt-7 hover:cursor-pointer" onClick={goHome}>
            FinGen
          </div>
        </div>
      </div>
      <div class="w-full block flex-grow lg:flex lg:items-center lg:w-auto mt-3">
        <div class="container text-sm lg:flex-grow">
          <button
            className="btn btn-design block mt-6 lg:inline-block lg:mt-0 text-[#73C4FC] text-3xl mx-2 ml-[5%] btn-2"
            onClick={goInvest}
          >
            Invest
          </button>
          <button
            class="btn btn-design block mt-6 lg:inline-block lg:mt-0 text-[#73C4FC] text-3xl mx-2 text-semibold"
            onClick={goEducation}
          >
            Education
          </button>
        </div>
        <div className="flex flex-row items-center">
          <button
            class="inline-block text-sm px-4 py-2 leading-none rounded-lg  text-2xl text-white border-white  mt-4 lg:mt-0 bg-[#73C4FC] mx-5 hidden"
            onClick={GoogleAuthProvider}
          >
            <i className="fab fa-google"></i>
            Sign up
          </button>

          {/* hidden until signed in */}

          {/* hidden until signed in */}
          {/* <span className="text-sm px-4 py-2 leading-none rounded-lg  text-2xl text-black">
            {"test: " + username}
          </span> */}
          <button
            className="button signout inline-block text-xl px-4 py-2 leading-none rounded-lg  text-2xl text-white border-white  mt-4 lg:mt-1 bg-[#73C4FC] whitespace-nowrap	mx-2 "
            onClick={() => {auth.signOut(); goLogin()}}
          >
            Sign in
          </button>

          <ProfilePic image={user?.photoURL} />
        </div>
      </div>
    </nav>
  );
}
